import UserList from "../Component/UserList";
import { connect } from 'react-redux';
import {
  getUserList, getGroupList, getFranchiseList,
  addUser, getUserEditDetail, updateEditedUSer,
  deleteUser, addNewGroup, getGroupDetails, deleteGroup, updateEditeGroup, getRoles
} from '../../../../Action';


const mapStateToProps = (state) => {
  const { UserList, GroupList, FranchiseList, AddUser, USerEditDetails,
    updateUser, DeleteUser, addGroup, GroupEditDetails, DeleteGroup, UpdateGroup, RoleList } = state;


  return {
    UserList, GroupList, FranchiseList, AddUser, USerEditDetails,
    updateUser, DeleteUser, addGroup, GroupEditDetails, DeleteGroup, UpdateGroup, RoleList
  }
}
const actionCreators = {
  getUserList,
  getGroupList,
  getFranchiseList,
  addUser,
  getUserEditDetail,
  updateEditedUSer,
  deleteUser,
  addNewGroup,
  getGroupDetails,
  deleteGroup,
  updateEditeGroup,
  getRoles
}
export default (connect(mapStateToProps, actionCreators)(UserList));